import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
export class TextureButtonLine extends React.Component {
    constructor(props) {
        super(props);
        this._id = TextureButtonLine._IdGenerator++;
        this._uploadInputRef = React.createRef();
        this.state = {
            isOpen: false,
        };
    }
    onChange(evt) {
        const files = evt.target.files;
        if (files && files.length) {
            this.props.onClick(files[0]);
        }
        evt.target.value = "";
    }
    render() {
        return (_jsxs("div", { className: "textureButtonLine", onPointerLeave: () => this.setState({ isOpen: false }), children: [_jsx("label", { htmlFor: "file-upload" + this._id, className: "file-upload", children: this.props.label }), _jsx("input", { ref: this._uploadInputRef, id: "file-upload" + this._id, type: "file", accept: this.props.accept, onChange: (evt) => this.onChange(evt) }), _jsx("div", { className: "dropdownButton", onClick: () => this.setState({ isOpen: !this.state.isOpen }), title: "Link to a texture", children: _jsx(FontAwesomeIcon, { icon: faLink }) }), _jsx("div", { className: "dropdown" + (this.state.isOpen ? "" : " hidden"), children: this.props.scene.textures
                        .filter((t) => t.name)
                        .sort((a, b) => (a.displayName || a.name).localeCompare(b.displayName || b.name))
                        .map((texture, index) => {
                        return (_jsx("div", { className: "dropdownItem", onClick: () => this.props.onLink(texture), title: texture.name, children: texture.displayName || texture.name }, index));
                    }) })] }));
    }
}
TextureButtonLine._IdGenerator = 0;
//# sourceMappingURL=textureButtonLineComponent.js.map